import _find from 'lodash/find';
import _get from 'lodash/get';

export const getContentfulFlavour = (flavours, flavour) => {
  const flavoursMapped = flavours.edges.map(e => e.node);
  if (flavour) {
    return _find(flavoursMapped, ['identifier', flavour]);
  } else {
    return _find(flavoursMapped, ['default', true]);
  }
};

export const mapFlavourDataStructure = flavourData => {
  return {
    ...flavourData,
    personalisation: {
      data: JSON.parse(
        _get(
          flavourData,
          'personalisation.configuration.internal.content',
          '{}'
        )
      ),
    },
  };
};

export const getDeetAnchor = ({ title }) => {
  return title.replace(/\s/g, '-').toLowerCase();
};

export const getMenuLinks = flavour => {
  return flavour.orderedDetail.deets.map(d => ({
    ...d,
    anchor: getDeetAnchor(d),
  }));
};
